import {
  Ruler,
  Cpu,
  Cog,
  Wrench,
  Disc3,
  Layers,
  Armchair,
  BatteryCharging,
  Route,
  FileText,
} from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";

const ITEMS = [
  { icon: Ruler, label: "Paint Thickness Measurement", span: "lg:col-span-2", slug: "paint-thickness" },
  { icon: Cpu, label: "ECU Diagnostics", span: "", slug: "ecu" },
  { icon: Cog, label: "Engine Inspection", span: "", slug: "engine" },
  { icon: Wrench, label: "Suspension Check", span: "", slug: "suspension" },
  { icon: Disc3, label: "Brake Inspection", span: "", slug: "brake" },
  { icon: Layers, label: "Underbody Inspection", span: "", slug: "underbody" },
  { icon: Armchair, label: "Interior Inspection", span: "", slug: "interior" },
  { icon: BatteryCharging, label: "Battery Health", span: "lg:col-span-2", slug: "battery" },
  { icon: Route, label: "Road Test", span: "", slug: "road-test" },
  { icon: FileText, label: "Digital Report", span: "", slug: "digital-report" },
];

export const WhyUs = () => (
  <section
    id="why-us"
    data-testid="why-us-section"
    className="border-y border-white/10 bg-[#0a0a0a] py-28 md:py-36"
  >
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter index="03" label="Why Choose Us" />
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-8 max-w-3xl font-heading text-4xl font-extrabold tracking-tight text-white md:text-6xl">
          A 300+ point checklist.
          <span className="block text-white/40">Zero guesswork.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((item, i) => (
          <Reveal key={item.slug} delay={0.05 * i} className={item.span}>
            <div
              data-testid={`why-card-${item.slug}`}
              className="group flex h-full items-center gap-5 rounded-3xl border border-white/10 bg-white/[0.03] p-6 transition-[transform,border-color,background-color] duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:bg-white/[0.05] md:p-7"
            >
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl border border-white/10 bg-black/40 text-white/70 transition-[color,border-color,transform] duration-500 group-hover:border-gold/40 group-hover:text-gold group-hover:scale-110">
                <item.icon className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <div>
                <span className="block text-[10px] font-bold uppercase tracking-[0.25em] text-gold/60">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="mt-1 block font-heading text-base font-bold tracking-tight text-white md:text-lg">
                  {item.label}
                </span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
